"use strict";

var _defineProperty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _objectWithoutProperties = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var _excluded = ["children"],
    _excluded2 = ["scope", "children"];
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // packages/react/context/src/index.ts


var index_exports = {};

__export(index_exports, {
  createContext: function createContext() {
    return createContext2;
  },
  createContextScope: function createContextScope() {
    return _createContextScope;
  }
});

module.exports = __toCommonJS(index_exports); // packages/react/context/src/create-context.tsx

var React = __toESM(require("react"));

var import_jsx_runtime = require("react/jsx-runtime");

function createContext2(rootComponentName, defaultContext) {
  var Context = React.createContext(defaultContext);

  var Provider = function Provider(props) {
    var children = props.children,
        context = _objectWithoutProperties(props, _excluded);

    var value = React.useMemo(function () {
      return context;
    }, Object.values(context));
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Context.Provider, {
      value: value,
      children: children
    });
  };

  Provider.displayName = rootComponentName + "Provider";

  function useContext2(consumerName) {
    var context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
  }

  return [Provider, useContext2];
}

function _createContextScope(scopeName) {
  var createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultContexts = [];

  function createContext3(rootComponentName, defaultContext) {
    var BaseContext = React.createContext(defaultContext);
    var index = defaultContexts.length;
    defaultContexts = [].concat(_toConsumableArray(defaultContexts), [defaultContext]);

    var Provider = function Provider(props) {
      var _scope$scopeName;

      var scope = props.scope,
          children = props.children,
          context = _objectWithoutProperties(props, _excluded2);

      var Context = (scope === null || scope === void 0 || (_scope$scopeName = scope[scopeName]) === null || _scope$scopeName === void 0 ? void 0 : _scope$scopeName[index]) || BaseContext;
      var value = React.useMemo(function () {
        return context;
      }, Object.values(context));
      return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Context.Provider, {
        value: value,
        children: children
      });
    };

    Provider.displayName = rootComponentName + "Provider";

    function useContext2(consumerName, scope) {
      var _scope$scopeName2;

      var Context = (scope === null || scope === void 0 || (_scope$scopeName2 = scope[scopeName]) === null || _scope$scopeName2 === void 0 ? void 0 : _scope$scopeName2[index]) || BaseContext;
      var context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }

    return [Provider, useContext2];
  }

  var createScope = function createScope() {
    var scopeContexts = defaultContexts.map(function (defaultContext) {
      return React.createContext(defaultContext);
    });
    return function useScope(scope) {
      var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(scopeName), _objectSpread(_objectSpread({}, scope), {}, _defineProperty({}, scopeName, contexts)));
      }, [scope, contexts]);
    };
  };

  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes.apply(void 0, [createScope].concat(_toConsumableArray(createContextScopeDeps)))];
}

function composeContextScopes() {
  for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
    scopes[_key] = arguments[_key];
  }

  var baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;

  var createScope = function createScope() {
    var scopeHooks = scopes.map(function (createScope2) {
      return {
        useScope: createScope2(),
        scopeName: createScope2.scopeName
      };
    });
    return function useComposedScopes(overrideScopes) {
      var nextScopes = scopeHooks.reduce(function (nextScopes2, _ref2) {
        var useScope = _ref2.useScope,
            scopeName = _ref2.scopeName;
        var scopeProps = useScope(overrideScopes);
        var currentScope = scopeProps["__scope".concat(scopeName)];
        return _objectSpread(_objectSpread({}, nextScopes2), currentScope);
      }, {});
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(baseScope.scopeName), nextScopes);
      }, [nextScopes]);
    };
  };

  createScope.scopeName = baseScope.scopeName;
  return createScope;
}